<script setup lang="ts">
import { ref } from "vue"

const open = ref(false)
</script>

<template>
    <span>
        <a
            href="#"
            class="tw-text-sm tw-cursor-pointer tw-text-customGray-300 hover:tw-text-secondary-200 hover:tw-underline"
            data-cy="consent-reopen"
            @click.prevent="open = true"
        >
            {{ $t("consent.reopen") }}
        </a>
        <ConsentPreferencesModal v-model="open" />
    </span>
</template>
